import { render, staticRenderFns } from "./acgSubList.vue?vue&type=template&id=2d658e46&scoped=true&"
import script from "./acgSubList.vue?vue&type=script&lang=js&"
export * from "./acgSubList.vue?vue&type=script&lang=js&"
import style0 from "./acgSubList.vue?vue&type=style&index=0&id=2d658e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d658e46",
  null
  
)

export default component.exports